import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button } from '@abb/uikit';
import React from 'react';
import { useTranslation } from 'react-i18next';
const SliderWrapper = (param)=>{
    let { emblaRef, children, ...rest } = param;
    return /*#__PURE__*/ _jsx(Box, {
        overflow: "hidden",
        maxWidth: "100%",
        ...rest,
        ref: emblaRef,
        children: children
    });
};
const SliderContainer = (param)=>{
    let { children, sx, ...rest } = param;
    return /*#__PURE__*/ _jsx(Box, {
        display: "flex",
        sx: {
            backfaceVisibility: 'hidden',
            touchAction: 'pan-y pinch-zoom',
            ...sx
        },
        ...rest,
        children: children
    });
};
const SliderItem = (param)=>{
    let { children, ...rest } = param;
    return /*#__PURE__*/ _jsx(Box, {
        minWidth: 0,
        flex: "0 0 100%",
        ...rest,
        children: children
    });
};
const SliderPrevButton = (props)=>{
    const { t } = useTranslation('common');
    return /*#__PURE__*/ _jsx(Button, {
        variant: "gray",
        "aria-label": "Previous button",
        ...props,
        children: t('actions.prev')
    });
};
const SliderNextButton = (props)=>{
    const { t } = useTranslation('common');
    return /*#__PURE__*/ _jsx(Button, {
        color: "semantic.source.white",
        "aria-label": "Next button",
        _hover: {
            bg: '#112B90' // brand.abbNew.tertiary
        },
        ...props,
        children: t('actions.next')
    });
};
export const Slider = {
    Wrapper: SliderWrapper,
    Container: SliderContainer,
    Item: SliderItem,
    PrevButton: SliderPrevButton,
    NextButton: SliderNextButton
};
